import { Box, Typography, TextField, Button, Paper } from "@mui/material";
import { useState } from "react";
import DashboardHeader from "../../Dashboard/DashboardHeader";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Platform } from "../../Utils/Const";
import api from "../../Utils/Api";
import { baseapi } from "../../Environmentalurl";

export default function PanVerification() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    pan: "",
    name: "",
    dob: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

const handleSubmit = async () => {
  try {
    const mobile = sessionStorage.getItem("mobileNumber");
    const aadhaarData = JSON.parse(sessionStorage.getItem("aadhaarData"));

    if (!mobile || !aadhaarData) {
      alert("Required data missing ❌");
      return;
    }

    // ============================
    // ✅ STEP 1: PAN VERIFY
    // ============================
    const panRes = await api.post(
      `${baseapi}/vciptransidcallbackurl/pan-dob-verification`,
      {
        ApplicationType: "1",
        EntityID: "65",
        GeoLocation: "12.9786,77.364",
        MachineID: "210.18.180.20",
        Mobilenumber: mobile,
        Platform: "2",
        ReqType: "Jan_Aadhaar_eWallet_PAN_Verification_2",
        PANNumber: form.pan,
        LinkPAN: "0",
        Purpose: "Y",
        Name: aadhaarData.citizenName,
        Fathername: "",
        Dob: aadhaarData.dob.replace(/-/g, "/"),
      }
    );

    if (panRes.data?.DobStatus !== "Y") {
      alert("DOB mismatch ❌");
      return;
    }

    console.log("✅ PAN VERIFIED");

    // ============================
    // ✅ STEP 2: UPDATE PAN
    // ============================
    const updateRes = await api.post(
      "https://staging.transactionanalysts.com:444/VCIP/vcip/AccountHolder/UpdatePanDetails",
      {
        mobileNumber: mobile,
        poi: form.pan,
        poiType: "pan",
        poiVerified: true,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "X-Company-Code": "ISU001",
        },
      }
    );

    if (updateRes.data?.resCode !== "000") {
      alert("PAN update failed ❌");
      return;
    }

    console.log("✅ PAN UPDATED");

    // ============================
    // 🔥 ONLY NOW CALL get-by-mobile
    // ============================
    const userRes = await api.get(
      `https://staging.transactionanalysts.com:444/VCIP/vcip/AccountHolder/get-by-mobile?mobileNumber=${mobile}`,
      {
        headers: {
          "X-Company-Code": "TA001",
        },
      }
    );

    if (userRes.data?.resCode !== "000") {
      alert("User data fetch failed ❌");
      return;
    }

    console.log("✅ USER DATA FETCHED");

    const userData = userRes.data.data[0];

    navigate("/kyc-userdetails", {
      state: userData,
    });

  } catch (error) {
    console.error(error);
    alert("Something went wrong ❌");
  }
};

const handleProceed = async () => {
  try {
    const mobile = sessionStorage.getItem("mobileNumber");

    const res = await api.post(
      "https://staging.transactionanalysts.com:444/VCIP/vcip/AccountHolder/GetVerificationStatus",
      {
        mobileNumber: mobile,
        EntityID: 65,
        platformId: Platform,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "X-Company-Code": "TA001"
        },
      }
    );

    const url = res.data?.data?.url;

    if (url) {
      window.location.href = url; // ✅ FINAL REDIRECT 
    } else {
      alert("KYC URL not available ❌");
    }

  } catch (err) {
    console.error(err);
    alert("Something went wrong ❌");
  }
};

  const formatDate = (date) => {
    if (!date) return "";

    // handle both formats safely
    if (date.includes("T")) {
      date = date.split("T")[0];
    }

    const [year, month, day] = date.split("-");

    return `${day}-${month}-${year}`;
  };

  return (
    <>
      <DashboardHeader />

      {/* FULL PAGE CENTER */}
      <Box
        sx={{
          minHeight: "90vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f5f7fb",
        }}
      >
        <Box width={{ xs: "90%", sm: 400 }}>
          {/* MAIN HEADING */}
          <Typography
            sx={{
              fontSize: 26,
              fontWeight: 700,
              textAlign: "center",
              mb: 3,
              color: "#111827",
            }}
          >
            Enter pan number
          </Typography>

          {/* CARD */}
          <Paper
            elevation={3}
            sx={{
              p: 3,
              borderRadius: 3,
              background: "#ffffff",
            }}
          >
            <Box display="flex" flexDirection="column" gap={2}>
              {/* PAN */}
              <TextField
                label="PAN Number"
                name="pan"
                value={form.pan}
                onChange={handleChange}
                fullWidth
                size="small"
              />

              {/* BUTTON */}
              <Button
                variant="contained"
                onClick={handleSubmit}
                sx={{
                  mt: 1,
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 2,
                }}
              >
                Verify PAN
              </Button>
            </Box>
          </Paper>
        </Box>
      </Box>
    </>
  );
}
